import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControlsOf } from '@y42/angular/forms';
import {
  DatasourceTableSettingsWriteSettingsPropertyName,
  DatasourceTableSettingsNavigationsConstant,
} from '../../model';
import { Y42WriteSettings } from '../../../../state';

@Component({
  selector: 'y42-write-settings[form]',
  templateUrl: './write-settings.component.html',
  styleUrls: ['./write-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WriteSettingsComponent {
  @Input() form!: FormGroup<FormControlsOf<Y42WriteSettings>>;
  navigationType = DatasourceTableSettingsNavigationsConstant[DatasourceTableSettingsWriteSettingsPropertyName];
}
